import { render, staticRenderFns } from "./RegistrationNextButton.vue?vue&type=template&id=256bb528&scoped=true&"
import script from "./RegistrationNextButton.vue?vue&type=script&lang=js&"
export * from "./RegistrationNextButton.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNextButton.vue?vue&type=style&index=0&id=256bb528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bb528",
  null
  
)

export default component.exports